import { apiClient } from "./apiclient";

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// employee / HR / team lead
export const createBackdateRequest = (data, token) =>
    apiClient.post("/backdate-requests", data, auth(token));          // { reportDate, reason }

export const getMyBackdateRequests = (token) =>
    apiClient.get("/backdate-requests/my", auth(token));

export const getMyApprovedBackdateDates = (token) =>
    apiClient.get("/backdate-requests/my/approved-dates", auth(token)); // ["2026-09-01", ...]

// admin
export const getAllBackdateRequests = (token) =>
    apiClient.get("/backdate-requests/admin", auth(token));

export const updateBackdateRequestStatus = (id, status, token) =>
    apiClient.patch(`/backdate-requests/${id}/status`, { status }, auth(token)); // APPROVED | REJECTED
